<template>
  <nuttrema-layout-form-standard :edit="true" :theme="theme">
    <template slot="center">

      <el-form
         label-width="25%"
        :ref="formRef"
        :model="formData"
        :rules="rules"
        :label-position="labelPosition">

        <section style="margin-bottom: 0">
          <el-row type="flex" justify="center">
            <el-col :xs="24" :md="24">
              <nuttrema-jumbotron>
                <h1>{{ $tc('label.hi_there_nice_to_see_you_again', haveName, { name: _get(PersonalProfile, 'data.first_name') }) }}</h1>
                <h4>{{ $t('label.type_in_your_credentials') }}</h4>
              </nuttrema-jumbotron>
            </el-col>
          </el-row>

          <el-row v-if="_get(error, 'error')" type="flex" justify="center" style="margin-bottom: 1.5em">
            <el-col :xs="22" :md="24">
              <nuttrema-form-alert
                 type="pink"
                 icon="far fa-exclamation"
                 icon-class-name="is-error"
                :error="error.error"
                :text="_get(error, 'error')"
                @close="handleClearError">
              </nuttrema-form-alert>
            </el-col>
          </el-row>

          <!-- <h4 class="section-title">{{ $t('label.type_in_your_credentials') }}</h4> -->
          <div class="section-items">
            <el-form-item :label="$t('label.email')" prop="email">
              <el-col :xs="24" :md="16">
                <el-input v-model="formData.email" @change="emailChanged"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.password')" prop="password">
              <el-col :xs="24" :md="16">
                <nuttrema-password-input v-model="formData.password" :checkStrong="false" @keyup.native.enter="submitForm"></nuttrema-password-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.remember_me')" style="margin-bottom: 0.5em">
              <el-col :xs="8" :md="12">
                <el-switch v-model="options.rememberMe" active-color="#ffc107"></el-switch>
              </el-col>
            </el-form-item>

            <el-form-item v-if="options.rememberMe">
              <el-col :xs="24" :md="16">
                <nuttrema-notification
                   theme="warning"
                  :closable="false"
                  :title="$t('label.remember_me')"
                  :sub-title="_markdown.renderInline($t('label.remember_me_text'))"
                  @close="handleClearError">
                </nuttrema-notification>
              </el-col>
            </el-form-item>

            <el-form-item>
              <el-col :xs="24" :md="8">
                <nuttrema-change-language placement="bottom" class="is-in-form"></nuttrema-change-language>
              </el-col>
              <el-col :xs="24" :md="8" class="is-align-right">
                <el-button type="text" @click="$emit('forgot-password')">{{ $t('label.forgot_password_question') }}</el-button>
              </el-col>
            </el-form-item>

            <el-form-item style="margin-bottom: 1em">
              <el-col :xs="24" :md="16">
                <el-button
                   type="nuttrema-dark-gray"
                   class="w-100"
                  :loading="options.loading"
                  @click="submitForm">
                  {{ $t('label.login') }}
                </el-button>
              </el-col>
            </el-form-item>

          </div>

          <div v-if="createInstance" class="section-help" style="margin-top: 2em">

            <el-row>
              <el-col :xs="16" :md="24" style="text-align: center">
                <router-link
                  class="el-button el-button--text"
                  :to="{ name: 'create-instance-professional-step-one' }">
                  {{ $t('label.dont_have_account') }}
                </router-link>
              </el-col>
              <el-col :xs="16" :md="24" style="text-align: center">
                <router-link
                   class="el-button el-button--text"
                  :to="{ name: 'professional-resend-completion-token' }">
                  {{ $t('label.purchase_confirmation_email_not_arrive') }}
                </router-link>
              </el-col>
            </el-row>

          </div>
          <!-- end ~ section-help -->

        </section>
      </el-form>

    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { clone, get } from 'lodash';

import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import NuttremaNotification from 'components/ui/alert/nuttrema-notification';
import NuttremaFormAlert from 'components/ui/alert/nuttrema-form-alert';
import NuttremaPasswordInput from 'components/ui/input/nuttrema-password-input';

import NuttremaJumbotron from 'components/ui/panels/nuttrema-jumbotron';
import NuttremaChangeLanguage from 'components/ui/button/nuttrema-change-language';

export default {
  name: 'form-participant-personal-information-cred',
  mixins: [FormStandardBehavior],
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
    error: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    createInstance: {
      type: Boolean,
      required: false,
      default: false,
    },
    RegionalAndLanguageAll: {
      required: false,
      default: null,
    },
    PersonalProfile: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaFormAlert,
    NuttremaJumbotron,
    NuttremaNotification,
    NuttremaPasswordInput,
    NuttremaChangeLanguage,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      options: {
        preferredLanguage: null,
        rememberMe: false,
        loading: false,
      },
      formData: {
        email: null,
        password: null,
      },
      rules: null,
    };
  },
  methods: {
    setRules() {
      this.rules = {
        email: [
          { required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.email', true),
          },
          { type: 'email',
            trigger: 'blur',
            message: this.formatValidationMessage('validation.invalid', 'label.email', true),
          },
        ],
        password: [
          { required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.password', true),
          },
        ],
      };
    },
    emailChanged(value) {
      this.$emit('emailChanged', value);
    },
    getFormData() {
      this.options.loading = true;
      return {
        payload: clone(this.formData),
        rememberMe: this.rememberMe,
      };
    },
    handleChangeLanguage(language) {
      this.$emit('changeLanguage', language);
      this.clearValidate();
      this.setRules();
    },
    handleClearError() {
      this.$emit('update:error', null);
    },
  },
  computed: {
    haveName() {
      return get(this.PersonalProfile, 'data.first_name') ? 2 : 1;
    },
  },
  created() {
    this.formRef = 'form-professional-login';
    this.options.preferredLanguage = this.$locale.current();
    this.setRules();
  },
  watch: {
    error() {
      this.options.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .section-help {
    margin-bottom: 0 !important;

    .section-help-row {
      justify-content: flex-end !important;
      > * {
        margin-right: 1em;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .is-for-phone-only {
    .section-items {
      margin-bottom: 5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/login/form-login.vue